/* eslint-disable no-restricted-syntax */
import { setPageType } from "action/utils/setPageType";
import Index from "container/articles/ArticlesContainer";
import axios from "fetch-api/fetch-api";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { wrapper } from "store";
import { ARTICLE_PAGE } from "util/product/product-constants";
import nextI18nextConfig from "../../../next-i18next.config";
import { pick } from "../../util/lodash/pick";

const articlesIds = [
  "ultimate-buying-guides",
  "ultimate-installation-guides",
  "diagnosis-guides",
  "error-codes",
  "wheels-and-tires",
  "latest-articles",
  "more-articles",
  "sustainable-mobility",
  "right-to-repair",
  "safety",
  "body-parts",
  "repair-costs",
  "oils-fluids-&-lubricants",
  "tools-and-equipment",
  "suspension-parts",
  "batteries-and-jumpstarters",
];

function filterFrSections(data, locale = "en") {
  const updatedData = { ...pick(data, articlesIds) };

  if (locale !== "fr") {
    return updatedData;
  }

  for (const key of Object.keys(updatedData)) {
    updatedData[key].title = updatedData[key].fr_title || updatedData[key].title;
    updatedData[key].description = updatedData[key].fr_desc || updatedData[key].description;
    updatedData[key].articles = updatedData[key].articles?.filter((item: any) => item.fr_title).map((eachSection) => ({
      ...eachSection,
      title: eachSection.fr_title || eachSection.title,
      description: eachSection.fr_desc || eachSection.description || "",
      subTitle: eachSection.fr_subtitle || eachSection.subTitle || "",
    }));
  }

  return updatedData;
}

function Articles(props: any) {
  return <Index {...props} />;
}

export const getServerSideProps = wrapper.getServerSideProps((store) => async ({ locale }) => {
  const { data: jsonData } = await axios.json(`${process.env.NEXT_PUBLIC_CMS}/articles-static-page/articles-v2.json`);
  const updatedJsonData = filterFrSections(jsonData, locale);
  const localesToLoad = ["common", "category-map", "auth"];
  const ssrTranslations = await serverSideTranslations(locale, localesToLoad, nextI18nextConfig);
  ssrTranslations._nextI18Next.initialI18nStore = {
    [locale]: ssrTranslations._nextI18Next.initialI18nStore[locale],
  };
  store.dispatch(setPageType(ARTICLE_PAGE));
  return {
    props: {
      ...ssrTranslations,
      ...updatedJsonData,
    },
  };
});

export default Articles;
